import type {
  CapacityLabel,
  CapacityStatus,
  QuantityUnit,
  BankCapacityRow,
} from './capacity.types'

export const PILOT_BANK = 'Union Investment Privatfonds GmbH'

export const CAPACITY_UNITS: QuantityUnit[] = ['TOJ', 'Std.', 'Tr.', 'Std.']
export const CAPACITY_UNIT_BY_LABEL: Record<CapacityLabel, QuantityUnit> = {
  TOJ: 'TOJ',
  Beratung: 'Std.',
  Schulung: 'Tr.',
  Pilot: 'Std.',
}

export function parseNumber(value: string): number {
  const cleaned = value.replace(/[^\d,-]/g, '').replace(',', '.')
  const parsed = Number(cleaned)
  return Number.isFinite(parsed) ? parsed : 0
}

export function formatQuantity(value: string, unit: QuantityUnit): string {
  return value === '—' ? value : `${value} ${unit}`
}

export function formatQuantityPair(done: string, ordered: string, unit: QuantityUnit): string {
  return `${done}/${ordered} ${unit}`
}

export function capacityUsagePct(ordered: string, frame: string): string {
  const base = parseNumber(frame)
  if (!base) return '—'
  return `${Math.round((parseNumber(ordered) / base) * 100)} %`
}

export function capacityRestPct(ordered: string, frame: string): string {
  const base = parseNumber(frame)
  if (!base) return '—'
  return `${Math.round(((base - parseNumber(ordered)) / base) * 100)} %`
}

export function serviceLabel(index: number): CapacityLabel {
  return (['TOJ', 'Beratung', 'Schulung', 'Pilot'] as CapacityLabel[])[index]!
}

export function zeitzielStatus(value: string): {
  label: string
  tone: 'green' | 'yellow' | 'red'
} {
  const index = parseNumber(value) / 100
  if (index > 1.1) return { label: 'deutlich über Plan', tone: 'yellow' }
  if (index > 1.05) return { label: 'leicht über Plan', tone: 'yellow' }
  if (index < 0.9) return { label: 'deutlich unter Plan', tone: 'red' }
  if (index < 0.95) return { label: 'leicht unter Plan', tone: 'red' }
  return { label: 'im Zielkorridor', tone: 'green' }
}

export function formatZeitzielIndex(value: string): string {
  const pct = parseNumber(value)
  if (!pct) return '—'
  return (pct / 100).toFixed(2).replace('.', ',')
}

export function statusColor(status: CapacityStatus): string {
  if (status === 'green') return 'green.solid'
  if (status === 'yellow') return 'yellow.solid'
  return 'red.solid'
}

export function statusLabel(status: CapacityStatus): string {
  if (status === 'green') return 'Im Plan'
  if (status === 'yellow') return 'Prüfen'
  return 'Auffällig'
}

export function bankListStatus(row: BankCapacityRow): CapacityStatus {
  const ordered = row.ordered.map(parseNumber)
  const done = row.done.map(parseNumber)
  const hasActiveOrder = ordered.some(v => v > 0)
  const hasOpenOrder = ordered.some((v, i) => v > done[i]!)
  if (!hasActiveOrder) return 'red'
  if (hasOpenOrder) return 'yellow'
  return 'green'
}

export function lastName(name: string): string {
  return name.trim().split(/\s+/).at(-1)?.toLowerCase() ?? name.toLowerCase()
}
